<template>
  <span>
    <el-dialog
      left
      :title="pageTitle"
      :width="dialogWidth"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      :visible.sync="showDialog"
      @close="handleCancelAddDocument"
      class="addDocumentsCard"
    >
      <div v-if="showFormFields">
        <div class="row">
          <div class="col-12">
            <div class="radio-wrapper">
              <l-radio
                v-bind:groupname="'section'"
                v-model="sectionType"
                value="Investment"
                label="Investment"
                >Investment</l-radio
              >
              <l-radio
                v-bind:groupname="'section'"
                v-model="sectionType"
                value="Fund"
                label="Fund"
                >Fund</l-radio
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="row">
              <div
                class="col-12"
                v-if="sectionType === 'Investment'"
                style="margin-bottom: 16px"
              >
                <div>
                  Company
                  <span class="required">*</span>
                </div>

                <vue-bootstrap-typeahead
                  :data="allCompanyList"
                  v-model="activeCompanyName"
                  class="diligenceAutoCompleteClass"
                  :serializer="checkCompany"
                  :minMatchingChars="1"
                  placeholder="Enter Company Name"
                  @hit="onAfterCompanySelection"
                  ref="addDocCompany"
                >
                  <template slot="suggestion" slot-scope="{ data }">
                    <div>
                      <div
                        class="dd-icon-wrapper"
                        v-if="
                          data.properties && data.properties.profile_image_url
                        "
                      >
                        <img
                          class="dd-icon"
                          height="30"
                          width="30"
                          :src="getImageUrl(data.properties.profile_image_url)"
                        />
                      </div>

                      {{ data.name || data.properties.name }}
                      <span class="gray" v-if="data && data.properties">{{
                        data.properties.short_description
                      }}</span>
                      <span class="gray" v-if="data.name"
                        >Company from your portfolio</span
                      >
                    </div>
                  </template>
                </vue-bootstrap-typeahead>
                <div class="col-12" v-if="activeCompanyName">
            <div style="padding-left: 15px">
              <div class="addCompanyBodyAnywayDiv">
                If your company is not listed above, you can
                <span
                  class="addCompanyBodyAnywaySpan"
                  @click="addAnyway(activeCompanyName)"
                  >Add Anyway</span
                >
                for now and we will continue to search “{{ activeCompanyName }}” in
                the mean time.
              </div>
            </div>
          </div>

                <div
                  class="icon-container"
                  style="right: 20px; top: 0px; z-index: 111"
                  v-if="companyListLoading"
                >
                  <i class="searchloader"></i>
                </div>
              </div>

              <div class="col-12">
                <div style="margin-bottom: 4px">
                  Type
                  <span class="required">*</span>
                </div>
                <el-select
                  class="todo-dropdown-el-select documents-dropdown-el-select"
                  size="large"
                  required
                  placeholder="Type"
                  v-model="activeDocumentType"
                  v-if="sectionType === 'Investment'"
                  @change="
                    DocumentTypeChange(
                      documentTypeUrlAdd[activeIndex],
                      'files',
                      'add'
                    )
                  "
                >
                  <el-option
                    v-for="item in vals.DOCUMENT_TYPE_OPTIONS"
                    :key="item.value"
                    :label="item.label"
                    :value="'id::' + item.value"
                  ></el-option>
                </el-select>

                <el-select
                  class="todo-dropdown-el-select documents-dropdown-el-select"
                  size="large"
                  required
                  placeholder="Type"
                  v-model="activeDocumentType"
                  v-if="sectionType === 'Fund'"
                  @change="
                    DocumentTypeChange(
                      documentTypeUrlAdd[activeIndex],
                      'files',
                      'add'
                    )
                  "
                >
                  <el-option-group
                    :key="'LP-Documents'"
                    :label="'LP Documents'"
                  >
                    <el-option
                      v-for="item in vals.LP_DOCUMENT_TYPE_OPTIONS"
                      :key="item.value"
                      :label="item.label"
                      :value="'lpd::' + item.value"
                    ></el-option>
                  </el-option-group>

                  <el-option-group
                    :key="'Formation-Documents'"
                    :label="'Formation Documents'"
                  >
                    <el-option
                      v-for="item in vals.FORMATION_DOCUMENT_TYPE_OPTIONS"
                      :key="item.value"
                      :label="item.label"
                      :value="'fd::' + item.value"
                    ></el-option>
                  </el-option-group>
                </el-select>
              </div>

              <div class="col-12" v-if="showLPEntity" style="padding-top: 16px">
                <div>
                  LP Entity
                  <span class="required">*</span>
                </div>
                <el-select
                  class="todo-dropdown-el-select"
                  size="large"
                  required
                  placeholder="Select LP Entity"
                  @change="handleLPEntityChange()"
                  v-model="activeLPEntity"
                >
                  <el-option
                    v-for="item in lpDetailsData"
                    :key="item._id"
                    :label="item.entity_name"
                    :value="item._id"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="row">
              <div class="col-12">
                <div>Date</div>

                <input
                  class="todo-form-date todo-form form-control"
                  type="date"
                  :value="
                    value.data.date &&
                    moment.utc(value.data.date).format('YYYY-MM-DD')
                      ? moment.utc(value.data.date).format('YYYY-MM-DD')
                      : moment.utc(new Date()).format('YYYY-MM-DD')
                  "
                  @input="value.data.date = moment($event.target.valueAsDate)"
                />
              </div>

              <div class="col-12">
                <div>Notes</div>
                <textarea
                  placeholder="Notes"
                  required="required"
                  rows="4"
                  cols="50"
                  class="form-control"
                  v-model="activeNote"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="showAttachments"
        class="row ml-0 mr-0"
        style="margin-top: 10px"
      >
        <div
          class="col-4 pl-0 pr-0"
          id="popover-target-1"
          style="/*padding-top: 6px;padding-left:0px;padding-right:0px*/"
        >
          <div
            class="attach-class d-flex justify-content-center align-items-center"
          >
            <div>
              <i class="fa fa-paperclip" aria-hidden="true"></i>
            </div>
            <div>Attach a file</div>
            <input
              type="file"
              ref="fileBtn"
              if="fileId"
              @change="handleFile"
              class="hidden"
            />
          </div>
        </div>
        <b-popover
          target="popover-target-1"
          triggers="hover"
          placement="top"
          custom-class="popover-modal-class"
        >
          <div
            class="m-2"
            style="cursor: pointer"
            @click="
              $refs.fileBtn.click();
              typeUrlCheck = false;
            "
          >
            From Computer
          </div>
          <div
            class="m-2"
            style="cursor: pointer"
            @click="typeUrlCheck = !typeUrlCheck"
          >
            Add Link
          </div>
        </b-popover>
        <div
          class="col-8 pl-0 pr-0"
          style="/*padding-top: 6px;*/"
          v-if="!typeUrlCheck"
          v-cloak
          @drop.prevent="addFile"
          @dragover.prevent
        >
          <div
            class="drag-drop-class d-flex justify-content-center align-items-center"
            style="height: 36px"
          >
            Drag and drop file to attach
          </div>
        </div>
        <div class="col-8" style="padding: 0" v-else>
          <form @submit.prevent="submitUrl">
            <input
              type="text"
              class="form-control team-form url-input-form"
              placeholder="Add a URL"
              id="myInput"
              @blur="submitUrl"
              v-model="urlValue"
              @
            />
          </form>
        </div>
      </div>
      <div v-if="showAttachments" class="mt-3">
        <div
          class="row ml-0 mr-0"
          v-if="url.add.length || url.update.length || files.add.length"
        >
          <div class="col-6 pl-0 pr-0">
            <div>Document Name</div>
          </div>
          <!-- <div class="col-6 pl-0 pr-0">
          <div style="padding-left: 5px">
            Document Type
            <span class="required">*</span>
          </div>
        </div> -->
        </div>
        <div v-if="url.add">
          <div
            v-for="(item, index) in url.add"
            :key="index"
            class="d-flex align-items-center fileItem my-2"
            style="padding-top: 0px; height: 45px"
          >
            <div class="col-6 pl-0 pr-0">
              <div class="d-flex">
                <a :href="formatUrl(item)" target="_blank">
                  <span style="width: 300px" class="attachment-name-class">{{
                    item
                  }}</span>
                </a>
              </div>
            </div>
            <div class="col-6 pl-0 pr-0">
              <div class="d-flex">
                <div class="col-10 pl-0 pr-0">
                  <!-- <el-select
                  class="todo-dropdown-el-select documents-dropdown-el-select"
                  size="small"
                  required
                  placeholder="Select Document type"
                  v-model="documentTypeUrlAdd[index]"
                  @change="
                    DocumentTypeChange(documentTypeUrlAdd[index], 'url', 'add')
                  "
                >
                  <el-option
                    v-for="item in vals.DOCUMENT_TYPE_OPTIONS"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select> -->
                </div>
                <div class="col-2">
                  <div style="margin-top: 5px">
                    <i
                      class="fas fa-times"
                      @click="deleteURL(index, 'add')"
                      style="cursor: pointer"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="url.update">
          <div
            v-for="(item, index) in url.update"
            :key="index"
            class="d-flex align-items-center fileItem my-2"
            style="padding-top: 0px; height: 45px"
          >
            <div class="col-6 pl-0 pr-0">
              <div class="d-flex">
                <a :href="formatUrl(item.url)" target="_blank">
                  <span style="width: 300px" class="attachment-name-class">{{
                    item.url
                  }}</span>
                </a>
              </div>
            </div>
            <div class="col-6 pl-0 pr-0">
              <div class="d-flex">
                <div class="col-10 pl-0 pr-0">
                  <!-- <el-select
                  class="todo-dropdown-el-select documents-dropdown-el-select"
                  size="small"
                  required
                  placeholder="Select Document type"
                  v-model="documentTypeUrlEdit[index]"
                  @change="
                    DocumentTypeChange(
                      documentTypeUrlEdit[index],
                      'url',
                      'edit'
                    )
                  "
                >
                  <el-option
                    v-for="item in vals.DOCUMENT_TYPE_OPTIONS"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select> -->
                </div>
                <div class="col-2">
                  <div style="margin-top: 5px">
                    <i
                      class="fas fa-times"
                      @click="deleteURL(index, 'update')"
                      style="cursor: pointer"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="files.add">
          <div
            v-for="(item, index) in files.add"
            :key="index"
            class="d-flex align-items-center fileItem my-2"
            style="padding-top: 0px; height: 45px"
          >
            <div class="col-6 pl-0 pr-0">
              <div class="d-flex justify-content-center align-items-center">
                <i
                  v-if="
                    item.type.includes('.doc') ||
                    item.name.includes('.doc') ||
                    item.name.includes('.txt')
                  "
                  class="fas fa-file-word mr-2"
                  style="color: #5190ff; /*padding-top:3px;*/"
                ></i>
                <i
                  v-else-if="
                    item.type.includes('zip') ||
                    item.name.includes('.zip') ||
                    item.type.includes('rar') ||
                    item.name.includes('.rar')
                  "
                  class="far fa-file-archive mr-2"
                  style="/*padding-top:3px;*/"
                ></i>
                <i
                  v-else-if="item.type.includes('image')"
                  class="fas fa-image mr-2"
                ></i>
                <i
                  v-else-if="
                    item.type.includes('csv') ||
                    item.type.includes('xls') ||
                    item.name.includes('.csv') ||
                    item.name.includes('.xls')
                  "
                  class="fas fa-file-excel mr-2"
                  style="color: #f15643; /*padding-top:3px;*/"
                ></i>
                <i
                  v-else-if="
                    item.type.includes('pdf') || item.type.includes('.pdf')
                  "
                  class="fas fa-file-pdf mr-2"
                  style="color: #f15643; /*padding-top:3px;*/"
                ></i>
                <!-- @click="handleDownload(item,'file')" -->
                <span
                  style="
                    cursor: pointer;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    flex-grow: 1;
                  "
                  >{{ item.name }}</span
                >
              </div>
            </div>
            <div class="col-6 pl-0 pr-0">
              <div class="d-flex justify-content-center align-items-center">
                <div class="col-10 pl-0 pr-0">
                  <!-- <el-select
                  class="todo-dropdown-el-select documents-dropdown-el-select"
                  size="small"
                  required
                  placeholder="Select Document type"
                  v-model="files.documentType[index]"
                  @change="
                    DocumentTypeChange(
                      files.documentType[index],
                      'files',
                      'add'
                    )
                  "
                >
                  <el-option
                    v-for="item in vals.DOCUMENT_TYPE_OPTIONS"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select> -->
                </div>
                <div class="col-2 pl-0 pr-0">
                  <div
                    style="
                      /*margin-top: 5px;*/
                      cursor: pointer;
                      padding-right: 10px;
                      padding-left: 10px;
                    "
                  >
                    <i
                      class="fas fa-times"
                      @click="deleteFile(index, 'add')"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="activeEmbedFileUrl && isShowPreview()">
        <embed :src="activeEmbedFileUrl" width="100%" height="325px" />
      </div>
      <div
        class="row text-center flex-center"
        v-if="activeEmbedFileUrl && !isShowPreview()"
        style="height: 325px; width: 100%"
      >
        Preview is not available for your document.
      </div>

      <div class="col-12 d-flex" style="padding: 0px">
        <div class="col-xl edit-company-action-button-row" style="padding: 0px">
          <button
            type="button"
            class="todo-form-cancel-button btn-outline-secondary"
            @click.prevent="handleCancelAddDocument"
          >
            Cancel
          </button>
          <button
            type="submit"
            @click.prevent="saveFileAndGotoNext"
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px; width: 150px"
            v-if="showFormFields"
            :disabled="showSpinner || saveDisable"
          >
            {{ activeParseButtonText }}
            <b-spinner
              v-if="showSpinner"
              style="float: right; position: absolute"
              small
              label="Loading..."
            ></b-spinner>
          </button>

          <button
            type="submit"
            @click.prevent="gotoParseDocs"
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px"
            v-if="showAttachments"
          >
            Next
          </button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      center
      title="Alert"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      width="390px"
      style="margin: 0 auto"
      :visible.sync="showParseCancel"
      class="team-modal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <div class="card-body">
        <div class="inputs row">
          <p style="width: 100%; text-align: left">
            You have cancelled the parsing process which will terminate the
            process from the current document.
            <br />
            Are you sure you want to continue ?
          </p>
        </div>
        <div class="actionbuttons">
          <button
            @click.prevent="handleParseCancel"
            class="todo-form-cancel-button btn-outline-secondary"
          >
            Cancel
          </button>
          <button
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px"
            @click="handleYesParseCancel"
          >
            Yes
          </button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      center
      title="Parsing In Progress"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      width="430px"
      style="margin: 0 auto"
      :visible.sync="showParsingNote"
      class="team-modal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <div class="card-body no_word_break">
        <div class="inputs row">
          <p style="width: 100%; text-align: left">Please check back later.</p>
          <p>
            Depending on the size of document and amount of pages this could
            take a bit of time.
          </p>
          <p>
            This process will continue in the background, it is safe to close
            this window.
          </p>
        </div>
        <div class="actionbuttons">
          <button
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px"
            @click="handleParsingNoteClose"
          >
            Close
          </button>
        </div>
      </div>
    </el-dialog>
  </span>
</template>
<script>
import { Dialog } from "element-ui";
import moment from "moment";
import { Select, Option, OptionGroup } from "element-ui";
import api from "../../../axios_api";
//import { Company, patchCompany } from "../../../models/Company";
//import { vals } from "../../../util";
import { mapGetters } from "vuex";
import { cbAdapter, vals } from "../../../util";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import config from "../../../../config/settings";
import { Company } from "../../../models/Company";
import { Radio } from "src/components/index";

const CRUNCHBASE_BASE_URL = "https://api.crunchbase.com/v3.1/";
const CRUNCHBASE_USER_KEY = "f488b788b922f095807326b936073e45";

export default {
  name: "addDocumentsCard",
  components: {
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
    [OptionGroup.name]: OptionGroup,
    [Radio.name]: Radio,
    VueBootstrapTypeahead,
  },
  props: {
    value: {
      isShow: Boolean,
      isCompanyDisabled: Boolean,
      data: Object,
    },
    portfolioItem: Object,
    context: String,
  },
  data() {
    return {
      showSpinner: false,
      monthArray: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      files: {
        add: [],
        update: [],
        delete: [],
        documentType: [],
      },
      url: {
        add: [],
        update: [],
        delete: [],
      },
      typeUrlCheck: false,
      urlValue: "",
      downloadLink: "",
      modalData: {},
      isCompanyDisabled: false,
      vals,
      documentTypeUrlAdd: [],
      documentTypeUrlEdit: [],
      deleteFlag: false,
      deleteData: {},
      showDeleteSpinner: false,
      selectedPortfolio: {},
      addShow: true,
      saveDisable: true,
      portfolioId: "",

      allCompanyList: [],
      companyListLoading: false,

      embedFileUrl: "",
      dialogWidth: "480px",
      showAttachments: true,
      showFormFields: false,

      activeNote: "",
      activeCompanyName: "",
      activeSelectedCompanyDeatils: null,
      activeEmbedFileUrl: "",
      activeDocumentType: "",
      activeIndex: -1,
      sectionType: "Investment",
      pageTitle: "Add Document",
      notificationFiles: [],
      activeParseButtonText: "Parse & Continue",
      activeLPEntity: "",
      activeLPEntityObject: null,
      filesToUpload: [],

      showParseCancel: false,

      showParsingNote: false,
    };
  },
  computed: {
    ...mapGetters("portfolio", ["portfolioAll"]),
    ...mapGetters("file", ["showAddModal"]),
    ...mapGetters("lpAllocations", ["lpDetailsData"]),
    moment() {
      return moment;
    },
    showDialog: {
      get() {
        if (this.showAddModal) {
          this.initializeModal();
        }
        return this.showAddModal;
      },
      set(value) {},
    },
    config() {
      return config;
    },
    showLPEntity() {
      let tmp = this.activeDocumentType
        ? this.activeDocumentType.split("::")
        : [];

      return this.sectionType === "Fund" && tmp[0] === "lpd";
    },
  },
  methods: {
    initializeModal() {
      let files = this.$store.getters["notifications/documentFileSelected"];

      if (this.context == "companyProfile" && this.value.data.portfolio_item)
        this.portfolioId = this.value.data.portfolio_item;
      else if (this.context == "DocumentPage" && files.length > 0) {
        let payload = [];
        files.map((item) => {
          let obj = {
            name: item.file_name,
            type: item.file_type,
            isStored: true,
            size: item.file_size ? item.file_size : 1433,
          };
          if (item.s3_location && item.s3_location.path)
            obj.s3_path = item.s3_location.path;
          payload.push(obj);
        });

        this.activeEmbedFileUrl = "";
        this.getFilePath(payload[0]);
        this.dialogWidth = "800px";
        this.showAttachments = false;
        this.showFormFields = true;

        this.activeIndex = 0;

        this.notificationFiles = payload;
        this.activeParseButtonText = "Parse";

        this.files.add = payload;

        this.filesToUpload = [...this.files.add];

        this.$store.commit("notifications/setFileData", []);
      }
    },
    formatUrl(url) {
      // make sure it starts w/ http(s)
      if (url.length > 1) {
        if (!url.startsWith("https")) url = "https://" + url;
        return url;
      } else return "";
    },
    handleFile(e) {
      let droppedFiles = e.target.files;
      if (!droppedFiles) return;
      [...droppedFiles].forEach((f) => {
        this.files.add.push(f);
      });
      this.checkValidations();
    },
    handleLPEntityChange() {
      let self = this;
      self.activeLPEntityObject = self.lpDetailsData.find((item) => {
        return self.activeLPEntity === item._id;
      });

      self.checkValidations();
      return true;
    },
    addFile(e) {
      let droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;
      [...droppedFiles].forEach((f) => {
        this.files.add.push(f);
      });
      this.checkValidations();
    },
    handleCancelAddDocument() {
      if (this.activeIndex > 0) {
        this.showParseCancel = true;
      } else {
        this.resetForm();
      }
    },
    handleYesParseCancel() {
      this.resetForm();

      this.showParsingNote = true;
    },
    handleParseCancel() {
      this.showParseCancel = false;
    },
    resetForm() {
      this.showParseCancel = false;

      this.$store.commit("file/showAddModal", false);
      this.portfolioId = "";
      this.files = {
        add: [],
        update: [],
        delete: [],
        documentType: [],
      };
      this.url = {
        add: [],
        update: [],
        delete: [],
      };
      this.urlValue = "";
      this.typeUrlCheck = false;
      this.showSpinner = false;
      this.documentTypeUrlAdd = [];
      this.documentTypeUrlEdit = [];
      this.isCompanyDisabled = false;
      this.selectedPortfolio = {};
      this.saveDisable = true;
      if (this.context == "companyProfile") {
        this.value.data.notes = "";
        this.value.data.date = "";
      } else {
        this.value.data = {};
      }

      this.activeEmbedFileUrl = "";
      this.activeCompany = "";
      this.activeDate = "";
      this.activeNote = "";
      this.activeIndex = -1;
      this.activeLPEntity = "";
      this.activeParseButtonText = "Parse & Continue";

      this.showAttachments = true;
      this.showFormFields = false;
      this.dialogWidth = "480px";
      this.pageTitle = "Add Document";
      this.notificationFiles = [];
    },
    saveFiles() {
      this.showSpinner = true;
      let self = this;
      if (this.context == "companyProfile") {
        if (this.portfolioItem && this.portfolioItem.hasOwnProperty("_id")) {
          this.selectedPortfolio = JSON.parse(
            JSON.stringify(this.portfolioItem)
          );
        }
      }
      let filePayload = {
        files: [],
        data: [],
        notificationFiles: [],
      };
      if (this.urlValue) {
        this.url.add.push(this.urlValue);
        this.urlValue = "";
      }
      this.files.add.map((item, index) => {
        if (item && item.isStored && item.s3_path) {
          filePayload.files.push(null);
          filePayload.data.push({
            _id: item._id,
            name: item.name,
            collection_name: "portfolio",
            document_id: this.selectedPortfolio._id,
            portfolio_item: this.selectedPortfolio,
            link_type: "File",
            isStored: item.isStored,
            s3_path: item.s3_path,
            date: this.value.data.date ? this.value.data.date : new Date(),
            notes: this.value.data.notes ? this.value.data.notes : "",
            document_type: this.files.documentType[index]
              ? this.files.documentType[index]
              : "",
          });
        } else {
          filePayload.files.push(item);
          filePayload.data.push({
            _id: item._id,
            name: item.name,
            collection_name: "portfolio",
            document_id: this.selectedPortfolio._id,
            portfolio_item: this.selectedPortfolio,
            link_type: "File",
            date: this.value.data.date ? this.value.data.date : new Date(),
            notes: this.value.data.notes ? this.value.data.notes : "",
            document_type: this.files.documentType[index]
              ? this.files.documentType[index]
              : "",
          });
        }
      });
      self.url.add.map((item, index) => {
        if (item) {
          filePayload.files.push(null);
          filePayload.data.push({
            _id: item._id,
            name: item.name,
            collection_name: "portfolio",
            document_id: this.selectedPortfolio._id,
            portfolio_item: this.selectedPortfolio,
            link_type: "URL",
            url: item,
            date: this.value.data.date ? this.value.data.date : new Date(),
            notes: this.value.data.notes ? this.value.data.notes : "",
            document_type: this.documentTypeUrlAdd[index]
              ? this.documentTypeUrlAdd[index]
              : "",
          });
        }
      });
      self.$store.dispatch("file/createFile", filePayload).then(
        (item) => {
          if (
            item.data.encrypt.limitExceededMessage &&
            item.data.encrypt.limitExceededMessage.length > 0 &&
            item.data.encrypt.limitExceededMessage == "Storage Limit Exceeded"
          ) {
            self.$toaster.error(
              "Storage limit exceeded. Upgrade your plan to add more"
            );
          } else {
            self.$toaster.success("Saved Successfully");
            this.gotoNextFile();
          }
          self.$emit("refresh", item);
        },
        (error) => {
          this.showSpinner = false;
          self.$toaster.error("Failed to add document");
        }
      );
    },

    saveNewCompany() {
      return new Promise((res) => {
        let self = this;

        let serverData = new Company({});
        serverData.cost = 0;
        serverData.value = 0;
        serverData.direct = "Direct";
        if (
          self.activeSelectedCompanyDeatils &&
          self.activeSelectedCompanyDeatils.properties &&
          self.activeSelectedCompanyDeatils.properties.permalink
        ) {
          serverData.name = self.activeSelectedCompanyDeatils.properties.name;

          serverData.website = self.activeSelectedCompanyDeatils.properties
            .homepage_url
            ? self.activeSelectedCompanyDeatils.properties.homepage_url
            : "";
          serverData.facebook = self.activeSelectedCompanyDeatils.properties
            .facebook_url
            ? self.activeSelectedCompanyDeatils.properties.facebook_url
            : "";
          serverData.linkedin = self.activeSelectedCompanyDeatils.properties
            .linkedin_url
            ? self.activeSelectedCompanyDeatils.properties.linkedin_url
            : "";
          serverData.twitter = self.activeSelectedCompanyDeatils.properties
            .twitter_url
            ? self.activeSelectedCompanyDeatils.properties.twitter_url
            : "";
          serverData.logo_url = self.activeSelectedCompanyDeatils.properties
            .profile_image_url
            ? self.activeSelectedCompanyDeatils.properties.profile_image_url
            : "";
          serverData.permalink = self.activeSelectedCompanyDeatils.properties
            .permalink
            ? self.activeSelectedCompanyDeatils.properties.permalink
            : "";
          serverData.cb_data = self.activeSelectedCompanyDeatils;
        } else {
          serverData.name = self.activeCompanyName;
          serverData.data_status = "Confirmed";
          serverData.company_status = "Unknown";
        }
        serverData
          .validate()
          .then((validateResponse) => {
            return serverData.writeToServer();
          })
          .then((dataFromServer) => {
            //self.refreshPortfolioTable(serverData);
            if (
              serverData.data_status == "Unconfirmed" &&
              serverData.permalink &&
              serverData.permalink != ""
            ) {
              let url = `${this.$route.params.account_id}/${this.$route.params.workspace_id}/company/confirm`;
              api
                .post(url, {
                  encrypt: {
                    data: {
                      company: serverData,
                      confirmedCompany: serverData.cb_data
                        ? serverData.cb_data
                        : {},
                    },
                  },
                })
                .then((confirmData) => {
                  this.$store
                    .dispatch("portfolio/_apiFetchPortfolio")
                    .then((data) => {
                      self.$store.dispatch("contacts/getContacts");
                      self.$store.dispatch("suggestions/getSuggestions");
                    })
                    .catch((error) => {
                      console.log("refresh error", error);
                    });
                })
                .catch((err) => {
                  this.$toaster.error("Unable to confirm company.");
                });
              res(dataFromServer);
            } else {
              self.$store.dispatch("contacts/getContacts");
              self.$store
                .dispatch("portfolio/_apiFetchPortfolio")
                .then((d) => {
                  let data = self.$store.getters["portfolio/portfolioData"];
                })
                .catch((error) => {
                  console.log("refresh error", error);
                });
              res(dataFromServer);
            }
          })
          .catch((error) => {
            console.log("validateResponse error", error);
            self.$toaster.error(error.error);
          });
      });
    },

    async createPortfolio() {
      let self = this;

      return new Promise(async (res, rej) => {
        let allCompanies = self.$store.getters["portfolio/portfolioData"];

        let dataFromServer = allCompanies.find((item) => {
          return (
            (self.activeSelectedCompanyDeatils &&
              self.activeSelectedCompanyDeatils._id &&
              self.activeSelectedCompanyDeatils._id == item._id) ||
            (self.activeSelectedCompanyDeatils &&
              self.activeSelectedCompanyDeatils.properties &&
              item.permalink ===
                self.activeSelectedCompanyDeatils.properties.permalink)
          );
        });

        if (!dataFromServer) {
          dataFromServer = await self.saveNewCompany();
        }
        res(dataFromServer);
      });
    },

    async saveFile() {
      let self = this;

      self.showSpinner = true;

      let portfolioData;

      if (self.sectionType === "Investment") {
        portfolioData = await self.createPortfolio();
      }

      let fileItem = self.filesToUpload[self.activeIndex];
      let fileBlob = null;

      let isUrlFile = false;
      if (typeof fileItem == "string") {
        isUrlFile = true;
      }

      if (isUrlFile || fileItem.s3_path) {
        fileBlob = null;
      } else {
        fileBlob = fileItem;
      }

      let tmp = self.activeDocumentType.split("::");
      let fundType = tmp[0];
      let docType = tmp[1];

      let filePayload;

      if (isUrlFile) {
        filePayload = {
          _id: undefined,
          name: undefined,
          link_type: "URL",
          url: fileItem,
          date: new Date(),
          notes: self.activeNote,
          document_type: docType,
        };
      } else {
        filePayload = {
          _id: fileItem._id,
          name: fileItem.name,
          link_type: "File",
          date: new Date(),
          notes: self.activeNote,
          s3_path: fileItem.s3_path,
          document_type: docType,
          isStored: fileItem.isStored,
        };
      }

      let url;
      if (self.sectionType === "Investment") {
        filePayload.document_id = portfolioData._id;
        filePayload.portfolio_item = portfolioData;
        filePayload.collection_name = "portfolio";
        url = "file/createFile";
      } else {
        if (fundType === "fd") {
          filePayload.document_id = new Date();
          filePayload.collection_name = "gp";
          filePayload.entity_type = "GP";
        } else {
          filePayload.collection_name = "lp";
          filePayload.entity_type = "LP";
          filePayload.document_id = this.activeLPEntityObject._id;
          filePayload.lp_item = this.activeLPEntityObject;
        }
        url = "lpAllocations/apiPostLpDocument";
      }

      self.$store
        .dispatch(url, {
          files: [fileBlob],
          data: [filePayload],
          notificationFiles: this.notificationFiles,
        })
        .then(
          (item) => {
            if (
              item.data.encrypt.limitExceededMessage &&
              item.data.encrypt.limitExceededMessage.length > 0 &&
              item.data.encrypt.limitExceededMessage == "Storage Limit Exceeded"
            ) {
              self.$toaster.error(
                "Storage limit exceeded. Upgrade your plan to add more"
              );
            } else {
              self.$toaster.success("Saved Successfully");
              self.gotoNextFile();
              self.showSpinner = false;
            }
            self.$store.dispatch("lpAllocations/apiFetchlpDocumentsData");

            self.$emit("refresh", item);
          },
          (error) => {
            self.showSpinner = false;
            self.$toaster.error("Failed to add document");
          }
        );
    },
    saveFileAndGotoNext() {
      this.saveFile();
    },
    gotoNextFile() {
      let self = this;

      self.activeIndex++;

      if (self.filesToUpload.length <= self.activeIndex) {
        self.resetForm();
        self.showParsingNote = true;
        return;
      }

      self.activeDocumentType = "";
      self.activeSelectedCompanyDeatils = null;
      self.activeCompanyName = "";
      self.activeNote = "";

      if (self.$refs.addDocCompany) {
        self.$refs.addDocCompany.inputValue = "";
      }

      self.activeEmbedFileUrl = "";
      setTimeout(() => {
        let url;
        let fileOrUrl = self.filesToUpload[self.activeIndex];
        if (typeof fileOrUrl === "string") {
          self.activeEmbedFileUrl = fileOrUrl;
        } else {
          self.activeEmbedFileUrl = URL.createObjectURL(fileOrUrl);
        }
      }, 100);

      self.pageTitle = `Add Document ${self.activeIndex + 1}/${
        self.filesToUpload.length
      }`;

      if (self.filesToUpload.length == self.activeIndex) {
        this.activeParseButtonText = "Parse";
      }

      this.checkValidations();
    },
    submitUrl() {
      this.urlValue = this.urlValue.trim();
      if (this.urlValue.length > 0) {
        this.url.add.push(this.urlValue);
        this.urlValue = "";
      }
      this.typeUrlCheck = false;
      this.checkValidations();
    },
    deleteFile(index, type) {
      if (type == "add") {
        this.files.add.splice(index, 1);
        this.files.documentType.splice(index, 1);
      } else {
        let data = this.files.update.splice(index, 1);
        this.files.delete.push(data[0]);
      }
      this.checkValidations();
    },
    deleteURL(index, type) {
      if (type == "add") {
        this.url.add.splice(index, 1);
        this.documentTypeUrlAdd.splice(index, 1);
      } else {
        let data = this.url.update.splice(index, 1);
        this.url.delete.push(data[0]);
      }
      this.checkValidations();
    },
    async getFilePath(item) {
      let urlData = await api
        .post(`/file/download`, {
          encrypt: {
            data: {
              s3_path: item.s3_path,
              file_type: item.type,
            },
          },
        })
        .catch((e) => {
          console.error("error: ", e);
        });

      if (
        urlData &&
        urlData.data &&
        urlData.data.encrypt &&
        urlData.data.encrypt.url
      ) {
        // window.open(urlData.data.encrypt.url);
        this.activeEmbedFileUrl = urlData.data.encrypt.url;
      }
    },
    async download(item) {
      let self = this;
      if (item.s3_path) {
        let urlData = await api
          .post(`/file/download`, {
            encrypt: {
              data: {
                s3_path: item.s3_path,
              },
            },
          })
          .catch((e) => {
            console.error("error: ", e);
          });
        if (
          urlData &&
          urlData.data &&
          urlData.data.encrypt &&
          urlData.data.encrypt.url
        ) {
          // window.open(urlData.data.encrypt.url);
          this.downloadLink = urlData.data.encrypt.url;

          setTimeout(() => {
            self.$refs.hiddenDownloadLink.click();
          });
        }
      } else {
        this.downloadLink = item.url;
        if (this.downloadLink.length > 1) {
          if (!this.downloadLink.startsWith("https"))
            this.downloadLink = "https://" + this.downloadLink;
        }
        setTimeout(() => {
          self.$refs.hiddenDownloadLink.click();
        });
      }
    },
    DocumentTypeChange(selected, context, operation) {
      this.checkValidations();
    },
    changeCompany(companyId) {
      if (companyId) {
        this.selectedPortfolio = this.portfolioAll.find((item) => {
          if (item._id == companyId) {
            return item;
          }
        });
      }
      this.checkValidations();
    },
    checkValidations() {
      if (
        ((this.sectionType === "Investment" &&
          (this.activeSelectedCompanyDeatils || this.activeCompanyName)) ||
          (this.sectionType === "Fund" && !this.showLPEntity) ||
          (this.sectionType === "Fund" &&
            this.showLPEntity &&
            this.activeLPEntity)) &&
        this.activeDocumentType
      ) {
        this.saveDisable = false;
      } else {
        this.saveDisable = true;
      }
    },

    async getCompanies(query) {
      this.companyListLoading = true;

      const response = await api.get(`search?key=${query}`);

      const suggestions = cbAdapter(response);

      this.companyListLoading = false;

      if (suggestions.data.items && suggestions.data.items.length > 0)
        this.allCompanyList = suggestions.data.items;
      else {
        this.allCompanyList = [
          {
            properties: {
              name: this.diligenceName,
              short_description: "No results Found. Continue..",
            },
          },
        ];
      }

      let allCompanies = this.$store.getters["portfolio/portfolioData"];

      let finalList = [].concat(allCompanies);
      for (let i = 0; i < this.allCompanyList.length; i++) {
        let found = false;
        for (let j = 0; j < allCompanies.length; j++) {
          if (
            allCompanies[j] &&
            this.allCompanyList[i] &&
            this.allCompanyList[i].properties &&
            this.allCompanyList[i].properties.permalink ==
              allCompanies[j].permalink
          ) {
            found = true;
          }
        }

        if (!found && this.allCompanyList[i]) {
          finalList.push(this.allCompanyList[i]);
        }
      }

      this.allCompanyList = [].concat(finalList);
    },
    checkCompany(item) {
      return item.name || item.properties.name || "";
    },
    onAfterCompanySelection(selectedValue) {
      let self = this;

      self.activeSelectedCompanyDeatils = selectedValue;

      self.checkValidations();
    },
    getImageUrl(image) {
      if (!image) {
        return;
      }
      // image.includes(
      //  "https://res-3.cloudinary.com/crunchbase-production/image/upload"
      //) ||
      if (
        image.includes(config.CRUNCHBASE_IMAGE_URL) ||
        image.includes("https://res") ||
        image.includes("static/img/generic-logo.png")
      ) {
        return image;
      }
      let imageId = image.slice(image.lastIndexOf("t_api_images/") + 13);
      if (!imageId || imageId.length == 0) {
        return image;
      }
      return `${config.CRUNCHBASE_IMAGE_URL}/${imageId}`;
    },

    gotoParseDocs() {
      this.showFormFields = true;
      this.showAttachments = false;
      this.dialogWidth = "800px";

      this.filesToUpload = [...this.url.add, ...this.files.add];

      this.gotoNextFile();
    },
    sectionChanged() {
      this.checkValidations();
    },
    isShowPreview() {
      let file = this.filesToUpload[this.activeIndex];

      if (!file) {
        return false;
      }

      if (typeof file == "string") {
        return true;
      }

      if (file.type.indexOf("image") != -1) {
        return true;
      }

      if (file.type.indexOf("pdf") != -1) {
        return true;
      }

      return false;
    },

    handleParsingNoteClose() {
      this.showParsingNote = false;
    }
  },

  watch: {
    activeCompanyName: _.debounce(function (addr) {
      if (addr.length > 0) {
        this.getCompanies(addr);
        this.checkValidations();
      }
    }, 500),
    sectionType: _.debounce(function (addr) {
      this.sectionChanged();
    }, 500),
  },
};
</script>

<style>

.no_word_break p{
  word-break: keep-all;
}

</style>